import { Table, TBody, TElement, THead, TRow } from '@adeccoux/tag-ds';
import { Onboarding } from '@models/onboarding.model';
import { Link } from '@mui/material';

const columns = [
  { field: 'userId', headerName: 'userId' },
  { field: 'clientOrganizationId', headerName: 'clientOrganizationId' },
  { field: 'configurationId', headerName: 'configurationId' },
  { field: 'applicationId', headerName: 'applicationId' },
  { field: 'url', headerName: 'Link' },
];

interface CandidatesRetriggeredTableProps {
  onboardingsRetriggered: Onboarding[];
}

export const CandidatesRetriggeredTable: React.FC<CandidatesRetriggeredTableProps> = ({ onboardingsRetriggered }) => {
  const generateCandidateUrl = (
    userId: string,
    clientOrganizationId: string,
    configurationId: string,
    applicationId: string | undefined,
  ) => {
    return `client-organization/${clientOrganizationId}/user-flow/${userId}/${applicationId}/${configurationId}`;
  };

  return (
    <div className="feature-bulk-retrigger __table-container ">
      <label className="tag-ds large">Candidates Internal Events Retriggered:</label>
      <Table>
        <THead>
          <TRow>
            {columns.map(({ field, headerName }) => (
              <TElement key={field}>{headerName}</TElement>
            ))}
          </TRow>
        </THead>
        <TBody>
          {onboardingsRetriggered?.length > 0 &&
            onboardingsRetriggered?.map((item: Onboarding) => (
              <TRow
                key={generateCandidateUrl(
                  item.userId,
                  item.clientOrganizationId,
                  item.configurationId,
                  item.applicationId,
                )}
              >
                <TElement>{item.userId}</TElement>
                <TElement>{item.clientOrganizationId}</TElement>
                <TElement>{item.configurationId}</TElement>
                <TElement>{item.applicationId}</TElement>
                <TElement>
                  <Link
                    href={generateCandidateUrl(
                      item.userId,
                      item.clientOrganizationId,
                      item.configurationId,
                      item.applicationId,
                    )}
                    target="_blank"
                    rel="noopener"
                  >
                    Check
                  </Link>
                </TElement>
              </TRow>
            ))}
        </TBody>
      </Table>
    </div>
  );
};
